export default function DrywallTypesElPaso() {
  const types = [
    {
      name: 'Standard Drywall',
      description: 'Most common type for interior walls and ceilings in residential and commercial buildings.',
      thickness: '1/2" or 5/8"',
      bestFor: 'General interior walls, ceilings, standard applications',
      image: 'https://public.readdy.ai/ai/img_res/12b8e5a8d8736489296c2d883d52b531.jpg'
    },
    {
      name: 'Moisture-Resistant Drywall',
      description: 'Green board or purple board designed for high-humidity areas like bathrooms and kitchens.',
      thickness: '1/2" or 5/8"',
      bestFor: 'Bathrooms, kitchens, laundry rooms, humid environments',
      image: 'https://readdy.ai/api/search-image?query=Moisture%20resistant%20green%20board%20drywall%20installation%20in%20modern%20bathroom%2C%20water-resistant%20panels%20in%20El%20Paso%20home%20with%20desert%20climate%20considerations%2C%20professional%20installation%20in%20humid%20areas%2C%20clean%20contemporary%20bathroom%20design%20with%20quality%20materials%2C%20construction%20detail%20photography&width=600&height=400&seq=drywall-type-002&orientation=landscape'
    },
    {
      name: 'Fire-Resistant Drywall',
      description: 'Type X drywall with special core additives providing enhanced fire protection for safety.',
      thickness: '5/8"',
      bestFor: 'Garages, furnace rooms, commercial buildings, fire-rated walls',
      image: 'https://readdy.ai/api/search-image?query=Fire%20resistant%20Type%20X%20drywall%20installation%20in%20commercial%20building%2C%20safety-rated%20panels%20for%20fire%20protection%20in%20El%20Paso%20construction%20project%2C%20professional%20grade%20materials%20for%20code%20compliance%2C%20industrial%20interior%20with%20quality%20fireproof%20walls%2C%20architectural%20safety%20photography&width=600&height=400&seq=drywall-type-003&orientation=landscape'
    },
    {
      name: 'Soundproof Drywall',
      description: 'Specialized panels with sound-dampening properties for noise reduction between rooms.',
      thickness: '1/2" or 5/8"',
      bestFor: 'Home theaters, bedrooms, offices, multi-family units',
      image: 'https://readdy.ai/api/search-image?query=Soundproof%20acoustic%20drywall%20installation%20in%20home%20theater%20room%2C%20noise-reducing%20panels%20in%20modern%20El%20Paso%20residence%2C%20professional%20sound%20dampening%20construction%2C%20quiet%20interior%20space%20with%20quality%20materials%2C%20residential%20entertainment%20room%20photography&width=600&height=400&seq=drywall-type-004&orientation=landscape'
    },
    {
      name: 'Impact-Resistant Drywall',
      description: 'Heavy-duty panels designed to withstand impacts and abuse in high-traffic areas.',
      thickness: '1/2" or 5/8"',
      bestFor: 'Schools, hospitals, commercial hallways, high-traffic areas',
      image: 'https://readdy.ai/api/search-image?query=Impact%20resistant%20durable%20drywall%20in%20commercial%20hallway%2C%20heavy-duty%20panels%20for%20high%20traffic%20areas%20in%20El%20Paso%20building%2C%20professional%20grade%20construction%20materials%2C%20modern%20commercial%20interior%20with%20reinforced%20walls%2C%20architectural%20durability%20photography&width=600&height=400&seq=drywall-type-005&orientation=landscape'
    },
    {
      name: 'Mold-Resistant Drywall',
      description: 'Advanced panels with mold-inhibiting properties for maximum moisture protection.',
      thickness: '1/2" or 5/8"',
      bestFor: 'Basements, bathrooms, areas prone to moisture and mold',
      image: 'https://readdy.ai/api/search-image?query=Mold%20resistant%20purple%20board%20drywall%20installation%2C%20advanced%20moisture%20protection%20panels%20in%20El%20Paso%20home%2C%20professional%20installation%20preventing%20mold%20growth%2C%20clean%20modern%20interior%20with%20quality%20materials%2C%20construction%20health%20and%20safety%20photography&width=600&height=400&seq=drywall-type-006&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Types of Drywall for El Paso Homes
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Choose the right drywall type for your project. Each type offers specific benefits for different applications and environments.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {types.map((type, index) => (
            <div key={index} className="bg-white rounded-xl overflow-hidden border-2 border-gray-200 hover:border-teal-500 transition-all">
              <div className="relative h-48 w-full">
                <img 
                  src={type.image} 
                  alt={type.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{type.name}</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">{type.description}</p>
                <div className="space-y-2 mb-4">
                  <div className="flex items-start gap-2">
                    <i className="ri-ruler-line text-teal-600 mt-0.5"></i>
                    <div>
                      <p className="text-xs font-semibold text-gray-900">Thickness</p>
                      <p className="text-xs text-gray-600">{type.thickness}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-teal-600 mt-0.5"></i>
                    <div>
                      <p className="text-xs font-semibold text-gray-900">Best For</p>
                      <p className="text-xs text-gray-600">{type.bestFor}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
